import axios from 'axios'

const axiosInstance = axios.create({
    baseURL: '/services/plugin-live-multi-company/custom-groups',
    headers: {
        'Access-Control-Allow-Origin': '*'
    }
})

const axiosPointInstance = axios.create({
    baseURL: '/services/plugin-points-of-interest/',
    headers: {
        'Access-Control-Allow-Origin': '*'
    }
})

const listCustomGroupApi = companyId => {
    return axiosInstance.get('', { params: { companyId } })
}

const createCustomGroupApi = customGroup => {
    return axiosInstance.post('/', customGroup)
}

const updateCustomGroupApi = customGroup => {
    return axiosInstance.put(`/`, customGroup)
}
const deleteCustomGroupOfCompany = customGroupID => {
    return axiosInstance.delete(`/delete/${customGroupID}`)
}
const resetPoiApi = resetGroupParams => {
    return axiosPointInstance.put('point/reset/', resetGroupParams)
}

export { listCustomGroupApi, createCustomGroupApi, updateCustomGroupApi, deleteCustomGroupOfCompany, resetPoiApi }
